<template>
    <div id='detail' class='main-content detail-overlay' v-prevent-scroll>
        <span class='fake-link go-back hidden-print' @click='goBack'> &lt;&lt; Go back to search</span>
        <detail></detail>
    </div>
</template>

<script>
    import DetailVue from './detail.vue'
    import FilterManager from './filterManager.js'
    import RouteManager from './routeManager.js'

    export default {
        components: {
            'detail': DetailVue
        },
        methods: {
            goBack: function () {
                var previous = RouteManager.getPrevious()
                if (previous && previous.name == 'search') {
                    this.$router.go(-1)
                } else {
                    RouteManager.setForce(true)
                    var query = FilterManager.generateQuery()
                    this.$router.push({name: 'search', query: query})
                }
            }
        }
    }
</script>

<style scoped>
    .detail-overlay {
        overflow-y: auto;
        position: fixed;
        background-color: white !important;
        width: 100%;
        height: 100%;
        z-index: 12;
        right: 0;
        left: 0;

        .go-back {
            margin-left: 5px;
            position: fixed;

            @media (max-width: 991px) {
                margin-left: 30px;
                position: initial;
            }
        }

        /* Display as though full page */
        margin-top: -117px;
        padding-top: 125px;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            padding-top: 80px;
        }
    }
</style>
